import { useEffect } from 'react';
import { pick } from 'ramda';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';
import { usePrevious } from 'js/hooks/usePrevious';
import { trackGamesMount, trackGameCategoryExpand } from '@core/js/components/main/Games/trackingApi';

export {
    trackGamesMount, trackGameCategoryExpand, trackGameCategorySwitch,
    trackGameCategoryActiveSlideChange, trackJackpotVisibility,
    trackGameSearchChange, trackGamesPersonalizedGrid2
} from '@core/js/components/main/Games/trackingApi';

// helpers

export const useTracking = () => {
    const { reactPortletId } = usePortletConfig();
    const { feedName, categories, expandedCategory } = usePortletSelector(pick([
        'feedName',
        'categories',
        'expandedCategory'
    ]));

    useEffect(() => {
        if (reactPortletId && feedName) {
            // this should be called once with relevant parameters. Might not be the best solution.
            trackGamesMount(reactPortletId, feedName);
        }
    }, [reactPortletId, feedName]);

    const prevExpanded = usePrevious(expandedCategory);
    useEffect(() => {
        if (expandedCategory && expandedCategory !== prevExpanded) {
            const categoryName = categories.find(cat => cat.cid === expandedCategory)?.name;

            trackGameCategoryExpand(reactPortletId, feedName, categoryName);
        }
    }, [expandedCategory, prevExpanded, feedName, categories, reactPortletId]);
};
